import {
  Navigate,
  Outlet,
} from 'react-router-dom';

import Payment from "./payment.component.js";
import useStore from "../hooks/useStore";

const PrivateRoute = ({ redirectPath = '/login' }) => {
  const loggedInUser = useStore(state => state.loggedInUser);

  var isauthentcated = loggedInUser != null;
  var isPaid = loggedInUser && loggedInUser.userStatus !== "NOT_PAID";

  console.debug("3. PrivateRoute");

  if (!isauthentcated) {
    return <Navigate to={redirectPath} replace />;
  }
  else {
    if (!isPaid) {
      return <Payment />;
    }
    else {
      return <Outlet />;
    }
  }
};
export default PrivateRoute;